<div *ngIf="buttonsList.length !== 0" class="wrapper" [attr.data-gtmlabel]="sectionTitle">
    <div class="title">
        {{ sectionTitle }}
    </div>

    <div class="buttons-region">
        <app-button
            *ngFor="let item of buttonsList"
            [btnColor]="colors.primaryButtonColor"
            [btnHoverColor]="colors.secondaryButtonColor"
            class="jump-to-button gtm-jump-button selenium-jump-button"
            (click)="jumpTo(isCollectionHomePage ? item.label : item.title)"
            [ngbTooltip]="isCollectionHomePage ? item.label : item.title"
            tooltipClass="premium-collection-tooltip"
            >{{
                (isCollectionHomePage ? item.preposition + " " + item.label : item.title)
                    | safeTruncate: 40 : windowSize.isSmallDesktop
            }}</app-button
        >
    </div>
</div>
